import Image from 'next/image';

/**
 * BranchPaymentSection 컴포넌트
 * 작성자: AI Assistant
 * 설명: 결제정보(결제 수단 리스트)를 렌더링합니다.
 * props:
 *   - paymentMethods: 결제 수단 문자열 배열
 */

interface BranchPaymentSectionProps {
  paymentMethods?: string[];
}

export default function BranchPaymentSection({
  paymentMethods,
}: BranchPaymentSectionProps) {
  // 결제수단이 없으면 섹션 전체를 숨김
  if (!paymentMethods || paymentMethods.length === 0) {
    return null;
  }

  return (
    <div className="desktop:flex desktop:pb-9 gap-4 pb-8">
      <div className="desktop:w-[100px] desktop:items-start desktop:pb-0 flex pb-4">
        <Image
          src="/images/icons/icon_payment.svg"
          alt="결제정보"
          width={24}
          height={24}
        />
        <span className="typo-20 text-level-3 pl-2 font-bold">결제정보</span>
      </div>
      <div className="typo-16 text-level-4 desktop:pl-6 desktop:typo-18 font-medium">
        {paymentMethods.join(', ')}
      </div>
    </div>
  );
}
